import * as React from "react";
import { useEffect, useState } from "react";
import { style } from "typestyle";
import { layout } from "../layout.js";
import { PushButton } from "../PushButton.js";
import { typography } from "../typography.js";
import { classNames, toT } from "../utils.js";
import { KeyPad, PhoneDigits } from "./KeyPad.js";
import { TextInput } from "./TextInput.js";
export function PhoneForm({ onSubmit, onCancel, strings }) {
    const [phone, setPhone] = useState("");
    const [pending, setPending] = useState(false);
    const [error, setError] = useState();
    const t = toT(strings);
    function getFeedback() {
        if (error) {
            return {
                message: `${error}`,
                "class": typography.colorError,
            };
        }
        else if (pending) {
            return {
                message: t("CheckingPhone"),
                "class": undefined,
            };
        }
        else {
            return {
                message: t("PleaseEnterPhone"),
                "class": typography.muted,
            };
        }
    }
    function handleType(value) {
        setPhone(phone + value);
    }
    function handleChange(value) {
        setPhone(value);
    }
    function handleSubmit() {
        submit(phone);
    }
    useEffect(() => {
        setError(false);
    }, [phone]);
    function submit(phone) {
        try {
            console.info("Submitting phone", phone);
            setPending(true);
            setError(false);
            setPhone(phone);
            onSubmit(phone);
            setError(false);
        }
        catch (error) {
            console.info("Submitting phone failed", phone);
            setError(error);
        }
        finally {
            setPending(false);
        }
    }
    const feedback = getFeedback();
    return (React.createElement("div", { className: classNames(layout.horizontal, layout.spaceEvenly) },
        React.createElement("div", { className: classNames(layout.vertical, layout.center, typography.alignCenter, phoneInputWidth) },
            React.createElement(TextInput, { value: phone, onChange: handleChange, type: "phone", disabled: pending, outline: true }),
            React.createElement("p", { className: feedback.class }, feedback.message),
            React.createElement("div", { className: button },
                React.createElement(PushButton, { primary: true, onClick: handleSubmit }, t("Submit"))),
            onCancel && (React.createElement("div", { className: button },
                React.createElement(PushButton, { onClick: onCancel }, t("Cancel"))))),
        React.createElement("div", { className: classNames(layout.vertical, layout.center) },
            React.createElement(KeyPad, { primary: true, round: true, size: 2, onType: handleType, disabled: pending, digits: PhoneDigits }))));
}
const phoneInputWidth = style({
    width: "24em",
});
const button = style({
    margin: "0.5em 0",
    textAlign: "center",
});
//# sourceMappingURL=PhoneForm.js.map